module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0699.6c585583.jpg";